module.exports = __webpack_public_path__ + "static/media/BoxPlotMCQ3_4.d286672d.svg";